export const LoginLayout = {
  type: "div",
  style: {
    backgroundImage: "url('/MemberLoginV2-01.png')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
  },
  className: "login-container",
  children: [
    {
      type: "div",
      className: "row justify-content-end align-items-center d-flex",
      style: {
        height: "100vh",
        width: "100vw",
        paddingRight: "3%"
      },
      children: [
        {
          type: "div",
          style: { maxWidth: "250px", marginRight: "42px" },
          children: [
            {
              type: "text",
              style: { fontSize: "54px", color: "#000000", fontWeight: "bold", lineHeight: "normal" },
              className: "login-header",
              content: "Now Everyone Can Earn"
            },
            {
              type: "text",
              style: { fontSize: "24px", color: "#000000", fontWeight: "bold", marginTop: "22px" },
              content: "Achieve your dreams. Your success starts here."
            }
          ]
        },
        {
          type: "div",
          className: "justify-content-center align-items-end d-fkex flex-column",
          children: [
            {
              type: "div",
              className: "px-4 d-flex flex-column align-items-center",
              style: {
                borderRadius: '10px',
                boxShadow: '5px 5px 5px rgba(0, 0, 0, 0.2)',
                background: "linear-gradient(to bottom, #8DC63F, #8FC743, #98CB51, #A5D268, #B8DB89, #D1E8B2 94%)",
                width: "434px",
                paddingTop: "50px",
                paddingBottom: "80px"
              },
              children: [
                {
                  type: "div",
                  className: "text-center",
                  style: { width: "100%" },
                  children: [
                    {
                      type: "img",
                      style: { width: "100%" },
                      altText: "client-logo",
                      src: "/Icons/JomMall_whiteversion_w-tag@3x.png"
                    }
                  ]
                },
                {
                  type: "text",
                  style: {
                    color: "#006838",
                    fontSize: "24px",
                    fontWeight: "bold",
                    marginTop: "34px",
                    marginBottom: "54px"
                  },
                  content: "Member Login"
                },
                {
                  type: "form",
                  style: { width: "100%" },
                  children: [
                    {
                      type: "input",
                      rules: [{ required: true, message: "{{PLEASE_ENTER_YOUR}} {{USERNAME}}" }],
                      // label: "{{USERNAME}}",
                      name: "username",
                      className: "",
                      inputConfig: {
                        placeholder: "{{ENTER}} {{USERNAME}}",
                        suffix: {
                          type: "img",
                          style: { width: "15px" },
                          src: "/Icons/login-page-username-input-icon.svg"
                        },
                        style: { borderRadius: "30px" },
                        className: "",
                        size: "large"
                      }
                    },
                    {
                      type: "input",
                      variant: "password",
                      rules: [{ required: true, message: "{{PLEASE_ENTER_YOUR}} {{PASSWORD}}" }],
                      // label: "{{PASSWORD}}",
                      name: "password",
                      className: "",
                      inputConfig: {
                        placeholder: "{{ENTER}} {{PASSWORD}}",
                        style: { borderRadius: "30px", marginBottom: "-10px" },
                        className: "",
                        size: "large"
                      }
                    },
                    {
                      type: "checkbox",
                      name: "remember_me",
                      label: "Remember Me",
                      style: { color: "#006838", fontSize: "13px", fontWeight: "bold" },
                    },
                    {
                      type: "button",
                      size: "large",
                      htmlType: "submit",
                      buttonType: "text",
                      className: "custom-color",
                      style: { backgroundColor: "#006838", color: "#ffffff", width: "100%", fontWeight: "bold", marginTop: "60px", marginBottom: "8px" },
                      children: [
                        {
                          type: "text",
                          content: "LOGIN"
                        }
                      ]
                    }
                  ]
                },
                {
                  type: "div",
                  className: "",
                  children: [
                    {
                      type: "text",
                      style: { fontSize: "13px", fontWeight: "bold", fontStyle: "italic" },
                      content: "<div class=\"text-center\"><a style=\"color: #000000;\" href=\"#/forgot-password\">{{FORGOT_PASSWORD}}?</a></div>"
                    },
                  ]
                }
              ]
            },
            {
              type: "footer",
              style: { minHeight: "5vh", color: "#B2B2B2" }
            }
          ]
        }
      ]
    }
  ]
}